import{v as i}from"./validation2.js";window.validation=i;
